import { BrxLink } from '@mediashop/app/bloomreach/types';
import { LinkOpenInTab } from '@mediashop/base/pattern/atom/LinkOpenInTab';
import { CSSProperties, useRef } from 'react';
import { useLocation } from 'react-router';
import { getIsNavItemActive } from '../../../helper';
import { BurgerMenuQuickLinksItemProps } from './index';

const componentName = 'burger-menu-quick-links-item';

const BurgerMenuQuickLinksItem = ({ closeBurgerMenu, quickLink }: BurgerMenuQuickLinksItemProps) => {
    const { pathname } = useLocation();
    const ref = useRef<HTMLLIElement>(null);

    const styles = {
        [`--${componentName}-font-color`]: quickLink.fontColorHex,
    } as CSSProperties;

    return (
        <li ref={ref} className={componentName} style={styles}>
            <LinkOpenInTab
                className={`${componentName}__link`}
                tab={quickLink.tab}
                onClick={closeBurgerMenu}
                link={quickLink.link}
                isActive={getIsNavItemActive((quickLink.link as BrxLink).reference, pathname)}
            >
                {(quickLink.link as BrxLink).text}
            </LinkOpenInTab>
        </li>
    );
};

export default BurgerMenuQuickLinksItem;
